import { IGerarBoletoSicoob } from './types';
import { padLeft } from '@/utils/pafLeft';
import { copy } from '@/utils/copy';
import { getFatorVencimento } from '@/utils/getFatorVencimento';

export function gerarDadosBoleto({ dados }: IGerarBoletoSicoob) {
  try {
    const { bancario, parcela } = dados;

    if (!bancario.modalidade) {
      bancario.modalidade = '01';
    }

    bancario.modalidade = padLeft(bancario.modalidade, 2);
    const codigo_cliente = `${bancario.codigo_cliente}${bancario.codigo_cliente_dv}`;

    const nossoNumero = getNossoNumero(bancario.agencia, codigo_cliente, String(parcela.id_boleto));
    const fatorVencimento = getFatorVencimento(parcela.vencimento);
    const valor = getValor(Number(parcela.valor));
    const campoLivre = '1' + bancario.agencia + bancario.modalidade +
      padLeft(codigo_cliente, 7) + nossoNumero + padLeft(parcela.parcela, 3);

    const digitoGeral = getDigitoGeral(`7569${fatorVencimento}${valor}${campoLivre}`);
    const codigoBarra = `7569${digitoGeral}${fatorVencimento}${valor}${campoLivre}`;

    const campo1 = copy(codigoBarra, 1, 3) + copy(codigoBarra, 4, 4) + copy(codigoBarra, 20, 24);
    const campo2 = copy(codigoBarra, 25, 34);
    const campo3 = copy(codigoBarra, 35, 44);
    const campo4 = copy(codigoBarra, 5, 5);
    const campo5 = copy(codigoBarra, 6, 9) + copy(codigoBarra, 10, 19);

    const digito1 = getDigito(campo1);
    const digito2 = getDigito(campo2);
    const digito3 = getDigito(campo3);
    const linhaDigitavel = campo1 + digito1 + campo2 + digito2 + campo3 + digito3 + campo4 + campo5;

    const dadosBoleto = {
      linhaDigitavel,
      fatorVencimento,
      valor,
      nossoNumero,
      campoLivre,
      digitoGeral,
      codigoBarra,
    };

    return dadosBoleto;
  } catch (error) {
    console.log('Falha ao gerar dados do boleto', error);
    return null;
  }
}

function getNossoNumero(
  agencia: string,
  codigo_cliente: string,
  id_boleto: string,
) {
  // formatar numeros
  codigo_cliente = padLeft(codigo_cliente, 10);
  id_boleto = padLeft(id_boleto, 7);

  // concatenar
  const aux = `${agencia}${codigo_cliente}${id_boleto}`;

  let i = 22, m = 3, soma = 0;
  while (true) {
    i--;
    soma += m * Number(copy(aux, i, i));
    if (i === 1) break;
    else if (m === 3) m = 7;
    else if (m === 7) m = 9;
    else if (m === 9) m = 1;
    else if (m === 1) m = 3;
  }

  // calcula o digito
  let dig = soma % 11;
  dig = (dig === 1 || dig === 0) ? 0 : 11 - dig;
  return `${id_boleto}${dig}`;
}

function getValor(valor: number) {
  const valorFormatado = valor.toFixed(2).replace(/\D/g, '');
  return padLeft(valorFormatado, 10);
}

function getDigitoGeral(texto: string) {
  let i = 43;
  let j = 1;
  let soma = 0;

  while (i >= 1) {
    j++;
    if (j === 10) j = 2;
    const valor = Number(copy(texto, i, i));
    soma += j * valor;
    i--;
  }

  const resto = soma % 11;
  let digito = 11 - resto;
  if (digito === 0 || digito > 9) digito = 1;

  return String(digito);
}

function getDigito(texto: string) {
  let i = texto.length;
  let j = 1;
  let total = 0;
  let soma = 0;
  let digito = 0;

  while (i >= 1) {
    j = j === 1 ? 2 : 1;

    let valor = Number(copy(texto, i, i));
    total = valor * j;

    if (total >= 10) {
      valor = Number(copy(total, 1, 1)) + Number(copy(total, 2, 2));
    } else {
      valor = total;
    }

    soma += valor;
    i--;
  }

  const uni = Number(copy(soma, String(soma).length, String(soma).length));
  digito = 10 - uni;
  if (digito === 10) digito = 0;
  return String(digito);
}
